module.exports = __webpack_public_path__ + "img/icon_edit.c33e0f67.svg";